import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';
import { CurrentUserService } from 'src/app/core/current-user.service';
import { AirCarrierHttpClient } from '../flight-log-api/air-carriers/air-carriers-client.service';
import { UserRole } from '../flight-log-api/shared/shared-client.model';

@Injectable({ providedIn: 'root' })
export class AirCarrierGuard {
  constructor(
    private _user: CurrentUserService,
    private _router: Router,
    private _airCarriers: AirCarrierHttpClient,
  ) {}

  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const airCarrierAbbreviation = next.paramMap.get('airCarrierAbbreviation');
    if (airCarrierAbbreviation === 'permissions') {
      return this._user.value?.userRoles.includes(UserRole.PrdAdmin) ?? false;
    }
    if (
      this._user.value != null &&
      this._user.value.accessibleAirCarriers.length > 0 &&
      airCarrierAbbreviation != null
    ) {
      return this.checkAirCarrierAuthorized(airCarrierAbbreviation);
    }
    const accessError = 'noAccessibleAirCarriers';
    this._router.navigate(['/unauthorized'], {
      queryParams: {
        error: accessError,
      },
    });
    return false;
  }

  public async checkAirCarrierAuthorized(airCarrierAbbreviation: string) {
    const allAirCarriers = this._airCarriers.getAll({}).pipe(map((res) => res.results));
    const accessibleAirCarriers = this._user.value?.accessibleAirCarriers;
    const isAuthorized = await allAirCarriers
      .pipe(
        map((airCarriers) => {
          const selectedAirCarrierId = airCarriers.filter(
            (ac) => ac.abbreviation === airCarrierAbbreviation,
          )[0].id;
          return accessibleAirCarriers?.find((value) => value.id === selectedAirCarrierId) != null
            ? true
            : false;
        }),
      )
      .toPromise();
    if (isAuthorized === true) {
      return true;
    } else {
      const accessError = 'airCarrierNotAccessible';
      this._router.navigate(['/unauthorized'], {
        queryParams: {
          error: accessError,
        },
      });
      return false;
    }
  }

  public canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this._user.value?.isPrdUser === true) {
      return true;
    }
    this._router.navigate(['/unauthorized']);
    return false;
  }
}
